import { FC } from 'react';

import { IconButton } from '@mui/material';
import { CloseButtonProps } from 'react-toastify/dist/components';

import s from './inactivityHandler.module.scss';

export const InactivityCloseButton: FC<CloseButtonProps> = ({ closeToast }) => {
  return (
    <IconButton
      onClick={closeToast}
      className={s.inactivityToastCloseButton}
    >
      ✖
    </IconButton>
  );
};
